import React, { FC } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import KeyMetric from 'components_new/pages/KeyMetric'
import KeyMetricGroups from 'components_new/pages/KeyMetricGroups'
import KeyMetricResources from 'components_new/pages/KeyMetricResources'
import KeyMetricSettings from 'components_new/pages/KeyMetricSettings'
import KeyMetrics from 'components_new/pages/KeyMetrics'

import { useIsAuthenticated } from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes: FC = () => {
  const isAuthenticated = useIsAuthenticated()

  return (
    <Switch>
      <AuthRoute
        Component={() => <KeyMetricResources />}
        isAuthenticated={isAuthenticated}
        path={'/key-metrics/:id/resources'}
      />
      <AuthRoute
        Component={() => <KeyMetricGroups />}
        isAuthenticated={isAuthenticated}
        path={'/key-metrics/:id/groups'}
      />
      <AuthRoute
        Component={() => <KeyMetricSettings />}
        isAuthenticated={isAuthenticated}
        path={'/key-metrics/:id/settings'}
      />
      <AuthRoute
        Component={() => <KeyMetric />}
        isAuthenticated={isAuthenticated}
        path={'/key-metrics/:id'}
      />
      <AuthRoute
        Component={() => <KeyMetrics />}
        isAuthenticated={isAuthenticated}
        path={'/key-metrics'}
      />
      <Route path={'/key-metrics/*'}>
        <Redirect to="/key-metrics" />
      </Route>
    </Switch>
  )
}

export default Routes
